<div class="generalPage" *ngIf="pageinitated">
  <div class="mx-2 related-content mt-3rem">
    <span class="font-32 content-blue ml-2 bold" role="heading" aria-level="2">{{title}}</span>
    <span (click)="Openlink($event)" id="/UnderDevelopment" class="ml-6px cursor-pointer"> <img src="../../../../assets/icons/Help.svg" class="learnmore-image image-info" alt="Archive"></span>

    <article class="answer font-16 content-blue width-100 mx-2" [innerHTML]="content"></article>
    <div *ngFor="let section of subcontent" class="subHeading mx-2">
      <article class="answer font-24 content-blue width-100 mb-2 bold">{{section.subheader}}</article>
      <article class="answer font-16 content-blue width-100">{{section.Content}}</article>

      <ul *ngFor="let item of section.Links">
        <li class="underline cursor-pointer"><a [id]="item.externalLink" (click)="Openlink($event)">{{item.linktext}}</a></li>
      </ul>
    </div>
  </div>




</div>
